export type OrgRole = 'owner' | 'admin' | 'member';
export type InvitableRole = 'admin' | 'member';

export const SUPPORTED_CURRENCIES = [
  'USD',
  'EGP',
  'EUR',
  'GBP',
  'SAR',
  'AED',
  'KWD',
  'QAR',
  'JOD',
  'MAD',
] as const;
export type CurrencyCode = (typeof SUPPORTED_CURRENCIES)[number];

export interface OrgSettings {
  currency: CurrencyCode;
  defaultMonthlyAiTokenCap: number | null;
  defaultMonthlyAdSpendCap: number | null;
}

export interface Organization {
  id: string;
  name: string;
  slug: string;
  role: OrgRole;
  settings: OrgSettings;
  createdAt: string;
}

export interface Member {
  userId: string;
  email: string;
  name: string;
  role: OrgRole;
  assignedProjectIds: string[];
  joinedAt: string;
}

export interface Invitation {
  id: string;
  email: string;
  role: InvitableRole;
  expiresAt: string;
  createdAt: string;
}

export interface InvitationPreview {
  organizationName: string;
  email: string;
  role: InvitableRole;
}
